import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Navbar from './components/Navbar';

const rootElement = document.getElementById('root');

const appContent = (
  <React.StrictMode>
    <Navbar />
    <App />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, appContent);
} else {
  createRoot(rootElement).render(appContent);
}

reportWebVitals();
